<script setup lang="ts">
import type { ErrorMessage } from '../../../types/chat'

import { computed } from 'vue'

import MarkdownRenderer from '../../markdown/MarkdownRenderer.vue'

const props = withDefaults(defineProps<{
  message: ErrorMessage
  label: string
  showPlaceholder?: boolean
  variant?: 'desktop' | 'mobile'
}>(), {
  showPlaceholder: false,
  variant: 'desktop',
})

const boxClasses = computed(() => [
  props.variant === 'mobile' ? 'px-2 py-2 text-sm' : 'px-3 py-3',
])
</script>

<template>
  <div flex :class="variant === 'mobile' ? 'mr-0' : 'mr-12'">
    <div
      flex="~ col"
      min-w-20 rounded-xl h="unset <sm:fit"
      class="comic-bubble comic-bubble-error"
      :class="boxClasses"
    >
      <div flex="~ row" gap-2>
        <div flex-1 class="inline <sm:hidden">
          <span text-xs text="black/70" font-normal font-who-dares>{{ label }}</span>
        </div>
        <div i-solar:danger-triangle-bold-duotone text-red-600 />
      </div>
      <div v-if="showPlaceholder" i-eos-icons:three-dots-loading text-black />
      <MarkdownRenderer
        v-else
        :content="message.content"
        class="break-words font-who-dares text-red-600"
      />
    </div>
  </div>
</template>

<style scoped>
.comic-bubble {
  background: white;
  border: 2px solid black;
}

.comic-bubble-error {
  box-shadow: 3px 3px 0 0 rgba(0, 0, 0, 0.7);
  border-color: #dc2626;
}
</style>
